export default __webpack_public_path__ + "static/media/adobe-express.e333adf3.svg";